<template>
    <div>
        <b-button v-b-tooltip.hover title="Alineación de contenido"
            variant="none" class="p-0" @click="onHandleOPenAlignmentOptions">
            <i class="fa fa-align-left" :style="{ fontSize: '25px' }"></i>
        </b-button>
        <b-toast id="show-options-alignment" title="Alineación de contenido" static
            class="position-absolute p-2 bg-white"
            :style="{ zIndex: 10, boxShadow: '#c4c4c4 0px 0px 18px -3px' }">
            
                <!-- Alineación solo contenido -->
                <div v-if="onSectionIfDifferentToTableComponents">
                    <div class="bg-light p-2 rounded w-100">
                        <i class="fa fa-arrows-v" aria-hidden="true"></i>
                        Alineación de contenido vertical
                    </div>
                    <div class="d-flex align-items-center justify-content-start mt-2">
                        <b-form-checkbox v-for="x in alignItems" :key="x.id" class="m-0 mr-1 border rounded" v-b-tooltip.hover :title="x.text" v-model="activeSection.alignItems" :value="x.id" button :button-variant="activeSection.alignItems === x.id ? 'light' : 'none'">
                            <i :class="`fa fa-${x.icon}`" aria-hidden="true"></i>
                        </b-form-checkbox>
                    </div>
                </div>

                <!-- Alineación del texto contenido -->
                <div :class="onSectionIfDifferentToTableComponents ? 'my-4' : 'mb-4'">
                    <div class="bg-light p-2 rounded w-100">
                        <i class="fa fa-arrows-h" aria-hidden="true"></i>
                        Alineación de contenido horizontal
                    </div>
                    <div class="d-flex align-items-center justify-content-start mt-2">
                        <b-form-checkbox v-for="x in justifyContent" :key="x.id" class="m-0 mr-1 border rounded" v-b-tooltip.hover :title="x.text" v-model="activeSection.justifyContent" :value="x.id" button :button-variant="activeSection.justifyContent === x.id ? 'light' : 'none'">
                            <i :class="`fa fa-${x.icon}`" aria-hidden="true"></i>
                        </b-form-checkbox>
                    </div>
                </div>

                <!-- Justificar texto -->
                <div class="my-2" v-if="showSettingsToText || showMaxFontSizeToSpecialSections">
                    <div class="bg-light p-2 rounded w-100">
                        <i class="fa fa-align-left" aria-hidden="true"></i>
                        Justificar texto
                    </div>
                    <div class="d-flex align-items-center justify-content-start mt-2">
                        <b-form-checkbox v-for="x in textAlign" :key="x.id" class="m-0 mr-1 border rounded" v-b-tooltip.hover :title="x.text"  v-model="activeSection.textAlign" :value="x.id" button :button-variant="activeSection.textAlign === x.id ? 'light' : 'none'">
                            <i :class="`fa fa-${x.icon}`" aria-hidden="true"></i>
                        </b-form-checkbox>
                    </div>
                </div>

                <b-button variant="dark" class="p-1 mt-2 text-white" size="sm" block
                    @click="$bvToast.hide('show-options-alignment')">
                    cerrar <i class="fa fa-check ml-1"></i>
                </b-button>

        </b-toast>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'AlignmentSettings',
    
    computed: {
        ...mapState('labelDesigner', [
            'activeSection',
            'textAlign',
            'justifyContent',
            'alignItems'
        ]),

        showSettingsToText() {
            if (!this.activeSection) return false
            return this.activeSection && (this.activeSection.type == 'text' || this.activeSection.type == 'TEXT' || this.activeSection.type === 'CLEAR_BOX') ? true : false
        },

        showMaxFontSizeToSpecialSections() {
            return ['PICTOGRAMS', 'WARNING_WORD', 'SAP_NUMBER', 'TRANSPORT', 'HAZARD_STATEMENTS', 'PRECAUTIONARY_INFO', 'EPPS', 'TABLE_COMPONENTS']
                .find(x => this.activeSection.code === x) ? true : false
        },

        onSectionIfDifferentToTableComponents() {
            return this.activeSection.code !== 'TABLE_COMPONENTS'
        }
    },

    methods: {
        onHandleOPenAlignmentOptions() {
            this.$bvToast.show('show-options-alignment')
        }
    }
}
</script> 